export const init = () => {

  // TRACKER 'HEADER'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.commons.header);


  // - HelpLinkClick - #1
  const HelpLinkClick = new AnalyticsClickEvent('HelpLinkClick', tracker.defaultEvent());
  HelpLinkClick.options.action = 'HelpLinkClick';
  HelpLinkClick.domContainer = '#dropdown-help';
  HelpLinkClick.params = {url_attr:'href'};
  HelpLinkClick.getLabel= function($element) { return $element.attr(this.params.url_attr);};
  tracker.addEvent(HelpLinkClick);

  // - HelpLink1Click #1.1
  const HelpLink1Click = new AnalyticsClickEvent('HelpLink1Click', tracker.defaultEvent());
  HelpLink1Click.options.action = 'HelpLink1Click';
  HelpLink1Click.domContainer = '#help-findAnswer';
  HelpLink1Click.params = {url_attr:'href'};
  HelpLink1Click.getLabel= function($element) { return $element.attr(this.params.url_attr);};
  tracker.addEvent(HelpLink1Click);


  // - HelpLink2Click #1.2
  const HelpLink2Click = new AnalyticsClickEvent('HelpLink2Click', tracker.defaultEvent());
  HelpLink2Click.options.action = 'HelpLink2Click';
  HelpLink2Click.domContainer = '#help-sendMail';
  HelpLink2Click.params = {url_attr:'href'};
  HelpLink2Click.getLabel= function($element) { return $element.attr(this.params.url_attr);};
  tracker.addEvent(HelpLink2Click);

  // - HelpLink2Click #1.3
  const HelpLink3Click = new AnalyticsClickEvent('HelpLink3Click', tracker.defaultEvent());
  HelpLink3Click.options.action = 'HelpLink3Click';
  HelpLink3Click.domContainer = '#help-findStore';
  HelpLink3Click.params = {url_attr:'href'};
  HelpLink3Click.getLabel= function($element) { return $element.attr(this.params.url_attr);};
  tracker.addEvent(HelpLink3Click);

  // - FindAStore #2
  const FindAStore = new AnalyticsClickEvent('FindAStore', tracker.defaultEvent());
  FindAStore.options.action = 'Account';
  FindAStore.options.label = 'FindAStore';
  FindAStore.domContainer = '#dropdown-find-store';
  tracker.addEvent(FindAStore);

  // - AccountGlobal #3
  const AccountGlobal = new AnalyticsClickEvent('AccountGlobal', tracker.defaultEvent());
  AccountGlobal.options.action = 'Account';
  AccountGlobal.options.label = 'Account - Global';
  AccountGlobal.domContainer = 'a.dropdown-account';
  tracker.addEvent(AccountGlobal);

  // - AccountmyAccount #3.1
  const AccountmyAccount = new AnalyticsClickEvent('AccountmyAccount', tracker.defaultEvent());
  AccountmyAccount.options.action = 'Account';
  AccountmyAccount.options.label = 'Account - MyAccount';
  AccountmyAccount.domContainer = '#accountLink';
  tracker.addEvent(AccountmyAccount);

  // - AccountMyLoyaltyAdvandtages #3.2
  const AccountMyLoyaltyAdvandtages = new AnalyticsClickEvent('AccountMyLoyaltyAdvandtages', tracker.defaultEvent());
  AccountMyLoyaltyAdvandtages.options.action = 'Account';
  AccountMyLoyaltyAdvandtages.options.label = 'Account - MyLoyaltyAdvandtages';
  AccountMyLoyaltyAdvandtages.domContainer = '#loyaltyLink';
  tracker.addEvent(AccountMyLoyaltyAdvandtages);

  // - AccountMyPurchases #3.3
  const AccountMyPurchases = new AnalyticsClickEvent('AccountMyPurchases', tracker.defaultEvent());
  AccountMyPurchases.options.action = 'Account';
  AccountMyPurchases.options.label = 'Account - MyPurchases';
  AccountMyPurchases.domContainer = '#purchasesLink';
  tracker.addEvent(AccountMyPurchases);

  // - AccountMyFavoriteStore #3.4
  const AccountMyFavoriteStore = new AnalyticsClickEvent('AccountMyFavoriteStore', tracker.defaultEvent());
  AccountMyFavoriteStore.options.action = 'Account';
  AccountMyFavoriteStore.options.label = 'Account - MyFavoriteStore';
  AccountMyFavoriteStore.domContainer = '#storeLink';
  tracker.addEvent(AccountMyFavoriteStore);
  // - AccountMyFavoriteStore #3.4b
  const AccountMyFavoriteStoreSelected = new AnalyticsClickEvent('AccountMyFavoriteStoreSelected', tracker.defaultEvent());
  AccountMyFavoriteStoreSelected.options.action = 'Account';
  AccountMyFavoriteStoreSelected.options.label = 'Account - MyFavoriteStore - ClickStore';
  AccountMyFavoriteStoreSelected.domContainer = '#header-my-account .store-name';
  tracker.addEvent(AccountMyFavoriteStoreSelected);

  // - AccountLogout #3.5
  const AccountLogout = new AnalyticsClickEvent('AccountLogout', tracker.defaultEvent());
  AccountLogout.options.action = 'Account';
  AccountLogout.options.label = 'Account - Logout';
  AccountLogout.domElement = '#header-my-account [data-target=\'#logout-header-confirmation\']';
  tracker.addEvent(AccountLogout);

  // - AccountLogout #3.5 - confirm
  const AccountLogoutConfirm = new AnalyticsClickEvent('AccountLogoutConfirm', tracker.defaultEvent());
  AccountLogoutConfirm.options.action = 'Account';
  AccountLogoutConfirm.options.label = 'Account - Confirm Logout';
  AccountLogoutConfirm.domElement = '#header-my-account a.logout-link';
  tracker.addEvent(AccountLogoutConfirm);

  // - Country #4
  const countryEvent = new AnalyticsClickEvent('countryEvent', tracker.defaultEvent());
  countryEvent.options.action = 'Country';
  countryEvent.domContainer = '.dropdown.lang-choice-header';
  countryEvent.domElement = 'li';
  countryEvent.params = {id_attr:'data-code'};
  countryEvent.getLabel = function($element) { return $element.attr(this.params.id_attr);};
  tracker.addEvent(countryEvent);

  // headerProceedToCheckout
  const headerProceedToCheckout = new AnalyticsClickEvent('headerProceedToCheckout', tracker.defaultEvent());
  headerProceedToCheckout.domContainer = '#header-my-cart';
  headerProceedToCheckout.domElement = 'a#dropdown-cart, div.checkout a';
  headerProceedToCheckout.options.category = 'Checkout - Basket';
  headerProceedToCheckout.options.action = 'ProceedToCheckout';
  headerProceedToCheckout.options.label = 'HeaderBasketLayout';
  headerProceedToCheckout.getValue = function($element) {
    if ($element.closest(this.domContainer).find('[data-tracking-cart-amount]').length)
      return $element.closest(this.domContainer).find('[data-tracking-cart-amount]').data('tracking-cart-amount');
    return $element.closest(this.domContainer).find('[data-tid="mini-cart-button"]').data('tracking-cart').split('|')[1];
  };
  tracker.addEvent(headerProceedToCheckout);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/commons/header-tracker.js